export default {
  social: {
    twitterUrl: `https://twitter.com/PennyLaneAI`,
    linkedInUrl: `https://www.linkedin.com/company/pennylaneai/`,
    youTubeUrl: `https://www.youtube.com/@PennyLaneAI`,
    gitHubUrl: `https://github.com/PennyLaneAI/pennylane`,
    slackUrl: `https://join.slack.com/t/xanadu-quantum/shared_invite/zt-1i8v8v49d-S76QxXm3OKCm9g0bvWvDpg`,
    discordUrl: `https://discord.com/invite/gnySM3nrN3`,
  },
  policies: [
    {
      name: 'Privacy Policy',
      link: '/privacy',
    },
    {
      name: 'Accessibility Policy',
      link: '/accessibility',
    },
    {
      name: 'Terms and Conditions',
      link: '/terms',
    },
    {
      name: 'Code of Conduct',
      link: '/conduct',
    },
  ],
}
